import { useEffect } from 'react';
import LoadingSpinner from '../../component/LoadingSpinner';


const ExternalRedirect = () => {
    useEffect(() => {
      // Redirect to the external URL
      window.location.href = 'https://eu-west-1poiwv0oq8.auth.eu-west-1.amazoncognito.com/login?client_id=25tjdubhvej2q63q8mlvlrqvba&response_type=code&scope=email+openid+phone&redirect_uri=https://wns-sentry.sony.eu/dashboard';
    }, []);
  
    return <div><LoadingSpinner/></div>;
  };
  export default ExternalRedirect;